function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "ic_vertical_align_top_24px",
  fill: "#fd101b",
  d: "M8 9.857h2.234V17h1.49V9.857h2.234L10.979 7z",
  transform: "rotate(180 7.229 9)"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Line_422",
  d: "M0 0L6 0",
  fill: "#fd101b",
  "data-name": "Line 422",
  transform: "translate(5.5 2.5)"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Line_423",
  d: "M0 0L4 0",
  fill: "#fd101b",
  "data-name": "Line 423",
  transform: "translate(5.5 4.5)"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Line_424",
  d: "M0 0L3 0",
  fill: "#fd101b",
  "data-name": "Line 424",
  transform: "translate(5.5 6.5)"
});
var SvgDescending = function SvgDescending(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_96_1",
    width: 12,
    height: 12,
    "data-name": "Component 96 \\u2013 1",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDescending, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/descending.8626204e.svg";
export { ForwardRef as ReactComponent };